import { observer } from "mobx-react-lite";

import { useNode } from "../../../node-context";

import { ProviderApiKeyPanel } from "@/components/ProviderApiKeyPrompt";
import { useWorkflow } from "@/components/Workflows/WorkflowCanvas/workflow-context";

const NodeProviderApiKeyPrompt = () => {
  const node = useNode();
  const workflow = useWorkflow();
  const providerApiKeyPrompt = node?.providerApiKeyPrompt;

  if (!node) {
    return null;
  }

  return (
    <div
      className={`overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out ${
        providerApiKeyPrompt
          ? "max-h-[1200px] opacity-100"
          : "pointer-events-none max-h-0 opacity-0"
      }`}
    >
      <div
        className={`transition-opacity duration-300 ease-in-out ${
          providerApiKeyPrompt ? "p-3 opacity-100" : "p-0 opacity-0"
        }`}
      >
        {providerApiKeyPrompt && (
          <ProviderApiKeyPanel
            provider={providerApiKeyPrompt.provider}
            onAfterProviderKeySaved={() => {
              workflow.clearNodeProviderApiKeyPrompts();
              if (providerApiKeyPrompt.retryMode === "play_from_here") {
                workflow.playFromHere(node);
                return;
              }
              workflow.run();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default observer(NodeProviderApiKeyPrompt);
